import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import "../styles.css";
import ContantLoader from "../ContantLoader";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { getAllAssets, getAllAssetsCount, uploadAsset } from "api/TemaplateApi";
import { toast } from "react-toastify";
var offSet = 0;
var matchNextButton = 1;

function Assets(props) {
  const [getTemplate, setGetTempale] = useState();
  const [fileName, setFilename] = useState();
  const [nextButton, setNextButton] = useState(1);
  const [showSearchData, setShowSearchData] = useState(true);

  useEffect(() => {
    getAllAssets(0)
      .then((data) => {
        setGetTempale(data);
      })
      .catch((e) => { });
    getAllAssetsCount()
      .then((data) => {
        setNextButton(Math.floor(data.count / 10));
      })
      .catch(function (error) {
        //
      });
  }, []);

  async function updateTemplates(files) {
    getAllAssets(offSet)
      .then((data) => {
        setGetTempale(data);
      })
      .catch((e) => { });
    getAllAssetsCount()
      .then((data) => {
        setNextButton(Math.floor(data.count / 10));
      })
      .catch((e) => { });
    toast.success(`${files.name} is uploaded `);
  }

  const uploadFile = async (event) => {
    const data = new FormData();
    const files = event.target.files[0];
    setFilename(files.name);
    data.append("file", files);

    uploadAsset(data)
      .then((res_data) => {
        updateTemplates(files);
      })
      .catch(function (error) { });
  };
  const PreviewDataShowing = async (e) => {
    e.preventDefault();
    offSet -= 8;
    //
    getAllAssets(offSet)
      .then((data) => {
        matchNextButton--;
        setGetTempale(data);
      })
      .catch((e) => { });
  };

  const NextDataShowing = async (e) => {
    e.preventDefault();
    matchNextButton++;
    // //
    offSet += 8;
    getAllAssets(offSet)
      .then((data) => {
        setGetTempale(data);
      })
      .catch((e) => { });
  };
  return (
    <div className="templates">
      <div className="page_heading">
        <h2>Assets</h2>
      </div>
      <div className="assets_list_outer">
        <div className="assets-head-bar">
          <div className="button-side-row">
            <span className="gray_btn">
              <input
                onChange={uploadFile}
                type="file"
                className="upload-file"
              />
              Upload
              <span className="upload-arrow ml-1">
                <i class="fas fa-cloud-upload-alt"></i>
              </span>
            </span>
          </div>
          <div className="d-flex">
            <span className="inline-label ml-auto">
              Page No. {matchNextButton} of {nextButton + 1}
            </span>
          </div>
        </div>
        <div className="assets-card-block">

          <div className="row">
            {
              //
            }
            {getTemplate ? (
              getTemplate.length > 0 ? (
                getTemplate.map((rows, index) => (
                  <div
                    key={index}
                    style={{ cursor: "default !important" }}
                    className="col-lg-3 col-md-4"
                  >
                    <div className="assets-card">
                      <figure className="assets-img">
                        <img src={rows.url} />
                      </figure>
                      <figcaption className="assets_card_des">
                        <h3>{rows.name}</h3>
                        {/* <p>1 day ago</p> */}
                      </figcaption>
                    </div>
                  </div>
                ))
              ) : (
                "No data available"
              )
            ) : (
              <ContantLoader />
            )}
          </div>
          {showSearchData ? (
            <div className="cstm-table-footer">
              <ul className="ftr-btn-list">
                <li>
                  {offSet === 0 ? (
                    <button
                      type="button"
                      className="table-data-btn btn-prev disabled-btn"
                      style={{
                        cursor: "not-allowed",
                        opacity: "0.6",
                      }}
                    >
                      <ArrowBackIosIcon />
                    </button>
                  ) : (
                    <button
                      onClick={PreviewDataShowing}
                      type="button"
                      class="table-data-btn btn-prev"
                    >
                      <ArrowBackIosIcon />
                    </button>
                  )}
                </li>
                <li>
                  {nextButton >= matchNextButton ? (
                    <button
                      onClick={NextDataShowing}
                      type="button"
                      class="table-data-btn btn-next"
                    >
                      <ArrowBackIosIcon />
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="table-data-btn btn-next disabled-btn"
                      style={{
                        cursor: "not-allowed",
                        opacity: "0.6",
                      }}
                    >
                      <ArrowBackIosIcon />
                    </button>
                  )}
                </li>
              </ul>
            </div>
          ) : (
            <div className="cstm-table-footer">
              <ul className="ftr-btn-list">
                <li>
                  {offSet === 0 ? (
                    <button
                      type="button"
                      className="table-data-btn btn-prev disabled-btn"
                      style={{
                        cursor: "not-allowed",
                        opacity: "0.6",
                      }}
                    >
                      <ArrowBackIosIcon />
                    </button>
                  ) : (
                    <button type="button" class="table-data-btn btn-prev">
                      <ArrowBackIosIcon />
                    </button>
                  )}
                </li>
                <li>
                  {nextButton >= matchNextButton ? (
                    <button type="button" class="table-data-btn btn-next">
                      <ArrowBackIosIcon />
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="table-data-btn btn-next disabled-btn"
                      style={{
                        cursor: "not-allowed",
                        opacity: "0.6",
                      }}
                    >
                      <ArrowBackIosIcon />
                    </button>
                  )}
                </li>
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Assets;
